import { reportContentConstants } from '../../_constants';

const initialState = { getOrientationListLoading: true, data: '', error: false };

export function getOrientationList(state = initialState, action) {

    switch (action.type) {
        case reportContentConstants.REQUEST_ORIENTATION_LIST:
            return {
                getOrientationListLoading: true,
                data: '',
                error: false
            };
        case reportContentConstants.RECEIVE_ORIENTATION_LIST:

            return {
                getOrientationListLoading: false,
                data: action.orientationList,
                error: false
            };
        case reportContentConstants.ORIENTATION_LIST_ERROR:
            return {
                getOrientationListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/reportContent/getOrientationList.reducer.js